import * as actionTypes from './types';

const initialState = {
    loading: false,
    error: false,
    categories: [],
    category: undefined,
};
const categoriesReducer = (state = { ...initialState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.TOGGLE_IS_FEATURE_CATEGORY_REQUEST:
        case actionTypes.DELETE_CATEGORY_REQUEST:
        case actionTypes.UPDATE_CATEGORY_REQUEST:
        case actionTypes.CREATE_NEW_CATEGORY_REQUEST:
        case actionTypes.GET_ALL_CATEGORIES_REQUEST: {
            return {
                ...state,
                error: null,
                loading: true
            };
        }
        case actionTypes.TOGGLE_IS_FEATURE_CATEGORY_SUCCESS:
        case actionTypes.DELETE_CATEGORY_SUCCESS:
        case actionTypes.UPDATE_CATEGORY_SUCCESS:
        case actionTypes.CREATE_NEW_CATEGORY_SUCCESS:
        case actionTypes.GET_ALL_CATEGORIES_SUCCESS: {
            return {
                ...state,
                categories: payload,
                loading: false,
                error: false
            };
        }
            
        case actionTypes.GET_CATEGORY_ID_SUCCESS: {
            return {
                ...state,
                category: payload,
                loading: false,
                error: false
            };
        }
        case actionTypes.TOGGLE_IS_FEATURE_CATEGORY_FAILED:
        case actionTypes.DELETE_CATEGORY_FAILED:
        case actionTypes.UPDATE_CATEGORY_FAILED:
        case actionTypes.CREATE_NEW_CATEGORY_FAILED:
        case actionTypes.GET_ALL_CATEGORIES_FAILED: {
            return {
                ...state,
                loading: false,
                error: payload
            };
        }

        default: {
            return {
                ...state
            };
        }
    }
};

export default categoriesReducer;
